"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const StatusBarItem_1 = require("./StatusBarItem");
const Button_1 = tslib_1.__importDefault(require("../../Button"));
const react_1 = tslib_1.__importDefault(require("react"));
const styled_components_1 = tslib_1.__importStar(require("../../Themes/styled-components"));
const Wrapper = (0, styled_components_1.default)(Button_1.default) `
  ${StatusBarItem_1.itemStyles}
  border-radius: 0;
  ${({ active }) => active &&
    (0, styled_components_1.css) `
      background: rgba(0, 0, 0, 0.1);
    `}
`;
const StatusBarDropdown = ({ className, onClick, children, active, }) => {
    return (react_1.default.createElement(Wrapper, { onClick: onClick, className: className, type: "button", active: active }, children));
};
exports.default = StatusBarDropdown;
